import React from 'react';
import { Link } from 'react-router-dom';
import { solutionsData } from '../data/mockData';
import { Building2, Server, Radio, ArrowRight } from 'lucide-react';
import { Button } from './ui/button';

const iconMap = {
  Building2,
  Server,
  Radio
};

// Map solution titles to their respective pages
const solutionLinks = {
  'Distribuidores IT': '/distribuidores-it',
  'MSPs': '/msps',
  'Telcos': '/telcos'
};

const Solutions = () => {
  return (
    <section id="solutions" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-2 bg-[#8bcaf9]/20 text-[#1297fd] rounded-full text-sm font-medium mb-4">
            Soluciones
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Una solución para{' '}
            <span className="text-[#1297fd]">tu negocio</span>
          </h2>
          <p className="text-lg text-[#c3c3c5] max-w-2xl mx-auto">
            Acelera tus negocios cloud con automatización de última generación
          </p>
        </div>

        {/* Solutions Grid */}
        <div className="grid md:grid-cols-3 gap-8">
          {solutionsData.map((solution, idx) => {
            const IconComponent = iconMap[solution.icon];
            const solutionLink = solutionLinks[solution.title] || '#';
            const isInternalLink = solutionLink.startsWith('/');

            return (
              <div
                key={solution.id}
                className="group relative bg-gradient-to-br from-gray-50 to-white rounded-3xl p-8 border border-[#e3e4e6] hover:border-[#8bcaf9] transition-all duration-500 hover:shadow-2xl hover:shadow-[#1297fd]/10 hover:-translate-y-2"
              >
                {/* Icon */}
                <div className="w-16 h-16 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300 shadow-lg" style={{ background: 'linear-gradient(135deg, #4E95D9, #2B6FA8)' }}>
                  {IconComponent && <IconComponent className="w-8 h-8 text-white" />}
                </div>

                {/* Content */}
                <h3 className="text-xl font-bold text-gray-900 mb-3">{solution.title}</h3>
                <p className="text-[#c3c3c5] mb-6 leading-relaxed">{solution.description}</p>

                {/* CTA */}
                {isInternalLink ? (
                  <Link
                    to={solutionLink}
                    className="inline-flex items-center text-[#1297fd] font-medium hover:text-[#40aaf8] group/link"
                  >
                    Saber más
                    <ArrowRight className="ml-2 w-4 h-4 transition-transform group-hover/link:translate-x-1" />
                  </Link>
                ) : (
                  <a
                    href={solutionLink}
                    className="inline-flex items-center text-[#1297fd] font-medium hover:text-[#40aaf8] group/link"
                  >
                    Saber más
                    <ArrowRight className="ml-2 w-4 h-4 transition-transform group-hover/link:translate-x-1" />
                  </a>
                )}

                {/* Hover Gradient Overlay */}
                <div className="absolute inset-0 rounded-3xl bg-gradient-to-br from-[#1297fd]/0 to-[#8bcaf9]/0 group-hover:from-[#1297fd]/5 group-hover:to-[#8bcaf9]/5 transition-all duration-500 pointer-events-none" />

                {/* Number Badge */}
                <div className="absolute top-6 right-6 w-10 h-10 bg-[#e3e4e6] rounded-full flex items-center justify-center text-[#c3c3c5] font-bold group-hover:bg-[#1297fd] group-hover:text-white transition-all">
                  {String(idx + 1).padStart(2, '0')}
                </div>
              </div>
            );
          })}
        </div>

        {/* CTA Banner */}
        <div className="mt-16 rounded-3xl p-8 sm:p-12 relative overflow-hidden" style={{ background: 'linear-gradient(135deg, #4E95D9, #2B6FA8)' }}>
          {/* Background Pattern */}
          <div className="absolute inset-0 opacity-10">
            <div className="absolute inset-0" style={{
              backgroundImage: `radial-gradient(circle at 50% 50%, white 1px, transparent 1px)`,
              backgroundSize: '30px 30px'
            }} />
          </div>

          <div className="relative flex flex-col sm:flex-row items-center justify-between gap-6">
            <div>
              <h3 className="text-2xl sm:text-3xl font-bold text-white mb-2">
                ¿Por qué Asisant es diferente?
              </h3>
              <p className="text-white/80">
                No solo proporcionamos una plataforma, nos convertimos en una extensión de tu equipo.
              </p>
            </div>
            <Link to="/contacto?source=experto">
              <Button
                size="lg"
                className="bg-white hover:bg-[#e3e4e6] text-[#1297fd] font-semibold px-8 py-6 rounded-full transition-all hover:scale-105 hover:shadow-xl whitespace-nowrap"
              >
                Hablar con un experto
                <ArrowRight className="ml-2 w-5 h-5" />
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Solutions;
